/**
 * Login
 */
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Axios } from '../utils/UtilityFunctions'
import { saveAs } from 'file-saver';
import UploadeFileLine from './uploadeFileLine'
import { List, ListItem, Divider, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { EmailOutlined, LockOpen, LockOutlined } from '@material-ui/icons';
import { useHistory } from "react-router-dom";
import { useDropzone } from 'react-dropzone'



const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const activeStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

export default function UploadFile(props) {

    const [uploadedFiles, setUploadedFiles] = useState([]);


    const onDrop = async acceptedFiles => {

        console.log('acceptedFiles', acceptedFiles)
        console.log('uploadedFiles', uploadedFiles)
        setUploadedFiles([...uploadedFiles, ...acceptedFiles])

    }



    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone(
        { accept: '.csv', onDrop });

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);

    const fileList = uploadedFiles.map((file, index) => {
        // return <ListItem color="primary" key={index}  >
        //     <ListItemText color="primary" primary={name} />
        //     <ListItemText primary={<>{uploadStatus ? 'uploaded' : "loading"}</>} />
        // </ListItem>
        return <UploadeFileLine file={file} key={index} />
    })

    return (
        <div className="container">
            <div {...getRootProps({ style })}>
                <input {...getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
            <div>
                <Divider />
                <List>
                    {fileList}
                </List>
            </div>
        </div>
    );
}


